import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  serviceAreas: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the serviceAreas
export const fetchServiceAreas = createAsyncThunk(
  "fetchServiceAreas/serviceAreas",
  async ({ enqueueSnackbar, limit = 100, page = 0, filter }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`trips/service-areas`, {
        params: {
          page: page + 1,
          limit,
          ...(filter &&
            filter.status && {
              status: filter.status,
            }),
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create serviceArea
export const createServiceArea = createAsyncThunk(
  "createServiceArea/serviceAreas",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`trips/service-areas`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update serviceArea
export const updateServiceArea = createAsyncThunk(
  "updateServiceArea/serviceAreas",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `trips/service-areas/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete serviceArea
export const deleteServiceArea = createAsyncThunk(
  "deleteServiceArea/serviceAreas",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`trips/service-areas/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const serviceAreaslice = createSlice({
  name: "serviceArea",
  initialState,
  extraReducers: (builder) => {
    // TODO: create serviceArea
    builder.addCase(fetchServiceAreas.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchServiceAreas.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.serviceAreas = action.payload;
    });

    builder.addCase(fetchServiceAreas.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create serviceArea
    builder.addCase(createServiceArea.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createServiceArea.fulfilled, (state, action) => {
      state.isLoading = false;
      state.serviceAreas.data = [
        action.payload.data,
        ...state.serviceAreas.data,
      ];
      state.serviceAreas.meta.total = state.serviceAreas.meta.total + 1;
      action.payload.enqueueSnackbar("SERVICEAREA is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createServiceArea.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update serviceArea
    builder.addCase(updateServiceArea.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateServiceArea.fulfilled, (state, action) => {
      state.isLoading = false;
      state.serviceAreas.data = state.serviceAreas.data.map((serviceArea) => {
        if (serviceArea.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return serviceArea;
        }
      });
      action.payload.enqueueSnackbar("SERVICEAREA is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateServiceArea.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete serviceArea
    builder.addCase(deleteServiceArea.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteServiceArea.fulfilled, (state, action) => {
      state.isLoading = false;
      state.serviceAreas.data = state.serviceAreas.data.filter(
        (serviceArea) => serviceArea.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("SERVICEAREA is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteServiceArea.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default serviceAreaslice.reducer;
